import { gql } from '@apollo/client';
import useGQLQuery from 'src/lib/graphql/hooks/useGQLQuery';
export const NOTE_DETAILS_QUERY = gql `
  query Admin_NoteDetails($noteID: ID!) {
    ep_noteDetails(noteID: $noteID) {
      id
      data {
        title
        topics
        slug
      }
      tabs {
        id
        data {
          title
          content
          sequence
          version
        }
      }
      ctime
      utime
    }
  }
`;
export function useNoteDetailsQuery(options) {
    return useGQLQuery(NOTE_DETAILS_QUERY, options);
}
